import {useGetIdentity} from "react-admin";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {SERVER_URL} from "../utils";
import {Box, LinearProgress} from "@material-ui/core";
import {useRef} from 'react';
import {useReactToPrint} from 'react-to-print';
import {Page, Text, View, Document, StyleSheet} from '@react-pdf/renderer';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {useFormik} from "formik";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";


const formValidationSchema = yup.object({
    idX: yup
        .number()
        .required('Inserisci la coordinata x del PAR Number'),
    idY: yup
        .number()
        .required('Inserisci la coordinata y del PAR Number'),
    nameX: yup
        .number()
        .required('Inserisci la coordinata x del Nomer del Prodotto'),
    nameY: yup
        .number()
        .required('Inserisci la coordinata x del Nome del Prodotto'),
    colorCodeX: yup
        .number()
        .required('Inserisci la coordinata x del ColorCode'),
    colorCodeY: yup
        .number()
        .required('Inserisci la coordinata x del ColorCode'),

});

export const ProfileEdit = ({staticContext, ...props}) => {
    const {loaded, identity, loading: identityLoading} = useGetIdentity();
    const [selectedImage, setSelectedImage] = useState(null);
    const [updating, setUpdating] = useState(false);
    const [loadingInfo, setLoadingInfo] = useState(false);
    const [customLabelInfo, setCustomLabelInfo] = useState(null);
    const componentRef = useRef();

    useEffect(() => {
        axios.get(SERVER_URL + "api/v1/seller/custom-label-info", {
            withCredentials: true,
        }).then(res => {
            setCustomLabelInfo(res.data)
            setLoadingInfo(true)
        });
    }, []);

    const formik = useFormik({
        initialValues: {
            idX: customLabelInfo ? customLabelInfo.idX : 160,
            idY: customLabelInfo ? customLabelInfo.idY : 163,
            nameX: customLabelInfo ? customLabelInfo.nameX : 160,
            nameY: customLabelInfo ? customLabelInfo.nameY : 130,
            colorCodeX: customLabelInfo ? customLabelInfo.colorCodeX : 40,
            colorCodeY: customLabelInfo ? customLabelInfo.colorCodeY : 30
        },

        validationSchema: formValidationSchema,
    });

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    if (identityLoading) return <LinearProgress/>;

    if (!loaded) {
        return null;
    }
    const reader = new FileReader();

    const blobToBase64 = (blob) => {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    if (loadingInfo) {
        formik.values.idX = customLabelInfo.idX
        formik.values.idY = customLabelInfo.idY
        formik.values.nameX = customLabelInfo.nameX
        formik.values.nameY = customLabelInfo.nameY
        formik.values.colorCodeX = customLabelInfo.colorCodeX
        formik.values.colorCodeY = customLabelInfo.colorCodeY
        setLoadingInfo(false)
    }
    return (
        <>
            <h1>Aggiorna Etichetta</h1>
            <div style={{
                border: "thick double black",
                width: "100%",
                height: "50%",
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap"
                }}>
                    <h2>Etichetta attualmente caricata</h2>
                    <div style={{flexBasis: "100%", height: 0}}></div>
                    <img alt={"not found"} width={"400px"} src={identity.img}/>
                </div>
            </div>
            <div style={{
                border: "thick double black",
                width: "100%",
                paddingBottom: "5%"
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap"
                }}>
                    <h2>Modifica Etichetta</h2>
                    <div style={{flexBasis: "100%", height: 0}}></div>
                    {selectedImage && (
                        <div>
                            <img alt="not fount" width={"250px"} src={URL.createObjectURL(selectedImage)}/>
                            <br/>
                            <button onClick={() => setSelectedImage(null)}>Remove</button>
                        </div>
                    )}
                    <br/>

                    <br/>
                    <div style={{flexBasis: "100%", height: 0}}></div>
                    <form style={{padding: "5%"}}>
                        <Grid container spacing={2}>
                            <Grid md={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="idX"
                                    label="Coordinata X - PAR Number"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.idX}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                            <Grid md={6} xs={12}>

                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="idY"
                                    label="Coordinata Y - PAR Number"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.idY}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                            <Grid md={6} xs={12}>

                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="nameX"
                                    label="Coordinata X - Nome del Prodotto"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.nameX}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                            <Grid md={6} xs={12}>

                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="nameY"
                                    label="Coordinata Y - Nome del Prodotto"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.nameY}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                            <Grid md={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="colorCodeX"
                                    label="Coordinata X - ColorCode"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.colorCodeX}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                            <Grid md={6} xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="colorCodeY"
                                    label="Coordinata Y - ColorCode"
                                    type="number"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.colorCodeY}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{
                                        marginBottom: "3%"
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <input
                            type="file"
                            name="myImage"
                            accept="image/*"
                            onChange={async (event) => {
                                console.log(event.target.files[0]);
                                setSelectedImage(event.target.files[0]);
                                reader.readAsDataURL(event.target.files[0]);
                                let base64String = await blobToBase64(event.target.files[0]);
                                console.log(base64String)
                            }}
                        />
                        <br/>
                        <Grid container spacing={4}>
                            <Grid md={6} xs={12}>
                                <Button onClick={async () => {
                                    setUpdating(true)
                                    let base64String = await blobToBase64(selectedImage);
                                    await axios.post(SERVER_URL + "api/v1/seller/update-label-image", {
                                        image: base64String,
                                    }, {
                                        withCredentials: true,
                                        headers: {
                                            'Content-Type': 'application/json; charset=utf-8'
                                        }
                                    }).finally(() => {
                                            setUpdating(false);
                                            alert("Etichetta aggiornata!");
                                            //window.location.reload();
                                        }
                                    );
                                }} variant="contained" style={{marginTop: "5%"}}>Aggiorna Etichetta</Button>
                            </Grid>
                            <Grid md={6} xs={12}>
                                <Button onClick={async () => {
                                    setUpdating(true)
                                    await axios.post(SERVER_URL + "api/v1/seller/update-label-coordinates", {
                                        idX: formik.values.idX,
                                        idY: formik.values.idY,
                                        nameX: formik.values.nameX,
                                        nameY: formik.values.nameY,
                                        colorCodeX: formik.values.colorCodeX,
                                        colorCodeY: formik.values.colorCodeY,
                                    }, {
                                        withCredentials: true,
                                        headers: {
                                            'Content-Type': 'application/json; charset=utf-8'
                                        }
                                    }).finally(() => {
                                            setUpdating(false);
                                            alert("Coordinate Aggiornate!");
                                            //window.location.reload();
                                        }
                                    );
                                }} variant="contained" style={{marginTop: "5%"}}>Aggiorna Coordinate</Button>
                            </Grid>
                        </Grid>
                        {updating && (
                            <>
                                Aggiornamento dell'etichetta...
                            </>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};